
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftRight75 as ObiThreewayAcuatorGenericInleftRight75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-right-75.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftRight75 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-right-75',
   elementClass: ObiThreewayAcuatorGenericInleftRight75Element,
   events: {
     
   }
  });
 
 